(function() {
	'use strict';

	var scrollOnHashClick = function() {
		if(this.href.indexOf('#') === -1) {
			return;
		}
		var destination = document.querySelector(this.href.substr(this.href.indexOf('#')));
		if(!destination) {
			return;
		}
		var duration = 700;
		var easeInOutQuad = function (t) {
			return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
		};

		var start = window.pageYOffset;
		var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

		var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
		var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
		var destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
		var headerHeight = document.querySelector('header').clientHeight;
		var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset) - headerHeight;

		if ('requestAnimationFrame' in window === false) {
			window.scroll(0, destinationOffsetToScroll);
		}

		function scroll() {
			var now = 'now' in window.performance ? performance.now() : new Date().getTime();
			var time = Math.min(1, ((now - startTime) / duration));
			var timeFunction = easeInOutQuad(time);
			window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

			if (window.pageYOffset === destinationOffsetToScroll) {
				return;
			}

			requestAnimationFrame(scroll);
		}

		scroll();
	};


	var buttons = document.querySelectorAll('a.ButtonBlock');
	for(var i=0; i<buttons.length; i++) {
		buttons[i].addEventListener('click', scrollOnHashClick);
	}

}());
